import axios from 'axios';
import config from './config';
import { useNavigate } from 'react-router-dom';

const api = axios.create({
    baseURL: config.apiBaseUrl,
});

// Добавляем перехватчик для обработки ошибок
api.interceptors.response.use(
    (response) => response, // Если ответ успешный, просто возвращаем его
    (error) => {
        if (error.response && error.response.status === 401) {
            // Если токен истек или недействителен, перенаправляем на страницу авторизации
            localStorage.removeItem('token');
            localStorage.removeItem('role');
            window.location.href = '/'; // Перенаправляем на главную страницу (авторизацию)
        }
        return Promise.reject(error);
    }
);

export default api;